'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Copyright 2017, IOOF Holdings Limited.
                                                                                                                                                                                                                                                                   * All rights reserved.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                                                                   */

var _lodash = require('lodash.isplainobject');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FILTER_INIT = { type: '@@FILTER/INIT' };

var filteredReducer = function filteredReducer(reducer) {
    var knownKeys = Object.keys(reducer(undefined, FILTER_INIT));

    return function (state, action) {
        var filteredState = state;

        if (knownKeys.length && state !== undefined) {
            filteredState = knownKeys.reduce(function (current, key) {
                current[key] = state[key];
                return current;
            }, {});
        }

        var newState = reducer(filteredState, action);

        if (newState === filteredState) {
            return state;
        }

        if ((0, _lodash2.default)(newState)) {
            knownKeys = Object.keys(newState);
            return _extends({}, state, newState);
        } else {
            return newState;
        }
    };
};

exports.default = filteredReducer;